import { useEffect, useMemo, useState } from "react";
import LoadingBackDrop from "../../global/LoadingBackDrop";
import { Box, Button, Divider, Typography, useMediaQuery } from "@mui/material";
import { Divide } from "react-feather";
import { getPayload } from "../../../services/api";
import dayjs from "dayjs";
import { formatNumberWithCommas } from "../../utils/UrlHandle";
import { Download } from "@mui/icons-material";
import PDFViewerDialog from "../../jasperReports/PDFViewerDialog";

const AnnualIncomeExpTable = () => {
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [mainData, setMainData] = useState({});
  const [testingDate, settestingDate] = useState(
    dayjs(new Date()).tz("Asia/Colombo", true)
  );
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const [openCashFlowDialog, setOpenCashFlowDialog] = useState(false);

  const handleCloseCashFlow = () => {
    setOpenCashFlowDialog(false);
  };

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    try {
      setLoading(true);
      const response = await getPayload.getPayloadData(
        `/dashboard/data?userId=${loggedUser.id}&testDate=${testingDate.format(
          "YYYY-MM-DD"
        )}&year=2026`
      );

      console.log("dash", response.data);

      const arrayIncome = response.data.listIncomeOnly;
      const arrayExpense = response.data.listExpenseOnly;

      const arrayProfit = arrayIncome.map(
        (value, index) => value - arrayExpense[index]
      );

      // console.log("arrpro ", arrayProfit);
      const totalProfit = arrayProfit.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);

      const totalIncome = arrayIncome.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);

      const totalExpense = arrayExpense.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);

      // Update state with all changes at once
      setMainData((prev) => ({
        ...response.data, // Spread all the response data
        listProfit: arrayProfit, // Add the calculated profit array
        profit: totalProfit,
        totalIncome,
        totalExpense,
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="success"
        size="small"
        onClick={() => setOpenCashFlowDialog(true)}
        startIcon={<Download />}
        loading={loading}
      >
        DOWNLOAD
      </Button>
      {loading && <LoadingBackDrop openBackDrop={loading} />}
      <Box
        display="grid"
        gap="30px"
        width="100%"
        gridTemplateColumns="repeat(9, minmax(0, 1fr))"
        sx={{
          margin: "3px 0px 3px 0px",
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 9",
          },
        }}
      >
        <Box
          sx={{
            gridColumn: "span 3",
            alignContent: "center",
          }}
          padding={1}
          display="flex"
          flexDirection="column"
        >
          <Typography variant="h4" textAlign="center" color="success">
            INCOME
          </Typography>
          <Divider />
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">1. January</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[0])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">2. February</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[1])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">3. March</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[2])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">4. April</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[3])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">5. May</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[4])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">6. June</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[5])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">7. July</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[6])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">8. August</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[7])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">9. September</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[8])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">10. October</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[9])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">11. November</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[10])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">12. December</Typography>
              <Typography variant="h5" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.listIncomeOnly[11])
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="h4"
                textAlign="center"
                width="100%"
                color="success"
              >
                TOTAL
              </Typography>
              <Typography variant="h4" color="success">
                {mainData?.listIncomeOnly
                  ? formatNumberWithCommas(mainData.totalIncome)
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
          </Box>
        </Box>
        <Box
          sx={{
            gridColumn: "span 3",
            alignContent: "center",
          }}
          padding={1}
          display="flex"
          flexDirection="column"
        >
          <Typography variant="h4" textAlign="center" color="error">
            EXPENSE
          </Typography>
          <Divider />
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">1. January</Typography>
              <Typography variant="h5" color="error">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[0])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">2. February</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[1])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">3. March</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[2])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">4. April</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[3])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">5. May</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[4])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">6. June</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[5])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">7. July</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[6])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">8. August</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[7])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">9. September</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[8])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">10. October</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[9])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">11. November</Typography>
              <Typography variant="h5" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[10])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">12. December</Typography>
              <Typography variant="h5" color="error">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listExpenseOnly[11])
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="h4"
                textAlign="center"
                width="100%"
                color="error"
              >
                TOTAL
              </Typography>
              <Typography variant="h4" color="error">
                {" "}
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.totalExpense)
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
          </Box>
        </Box>
        <Box
          sx={{
            gridColumn: "span 3",
            alignContent: "center",
          }}
          padding={1}
          display="flex"
          flexDirection="column"
        >
          <Typography variant="h4" textAlign="center" color="warning">
            SAVING
          </Typography>
          <Divider />
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">1. January</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[0])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">2. February</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[1])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">3. March</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[2])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">4. April</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[3])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">5. May</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[4])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">6. June</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[5])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">7. July</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[6])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">8. August</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[7])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">9. September</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[8])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">10. October</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[9])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">11. November</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[10])
                  : "0.00"}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5">12. December</Typography>
              <Typography variant="h5" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.listProfit[11])
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="h4"
                textAlign="center"
                width="100%"
                color="warning"
              >
                TOTAL
              </Typography>
              <Typography variant="h4" color="warning">
                {mainData?.listExpenseOnly
                  ? formatNumberWithCommas(mainData.profit)
                  : "0.00"}
              </Typography>
            </Box>
            <Divider />
          </Box>
        </Box>
      </Box>
      <PDFViewerDialog
        reportNo={`CASH_FLOW_${2022}`}
        open={openCashFlowDialog}
        handleCloseReportPreview={handleCloseCashFlow}
        letterHead={""}
        reportType={"ANNUALINCOMEEXPENSE"}
      />
    </Box>
  );
};

export default AnnualIncomeExpTable;
